import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
// import SuperTagHelper from "@/components/functionals/SuperTagHelperDashBoard.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import formatterAutoMV from "@/components/functionals/formatterAutoMV.vue";

export default [
  {
    prop: "Id",
    label: "# Tr.",
    width: 80,
    sortable: true
  },
  {
    prop: "Name",
    label: "Tarea",
    minWidth: 180,
    sortable: true
  },
  {
    prop: "Responsable",
    label: "Responsable",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "ImageResponsable"
    }
  },
  {
    prop: "CreatorTask",
    label: "Creado",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "CreatorTaskImage"
    }
  },
  {
    prop: "Status",
    label: "Estado",
    width: 200,
    sortable: true,
    formatter: formatterAutoMV
  },
  {
    prop: "PercentageProsposal",
    label: "Progreso",
    width: 200,
    sortable: true,
    formatter: formatterAutoMV
  },
  {
    prop: "PerpectiveID",
    label: "Tipo Perspectiv",
    width: 200,
    sortable: true,
    formatter: formatterAutoMV
  },
  {
    prop: "InitialDate",
    label: "Fecha Inicio",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "TypeStrategic",
    label: "Tipo",
    width: 200,
    sortable: true,
    formatter: formatterAutoMV
  },
  {
    prop: "Duration",
    label: "Duracción",
    width: 110,
    sortable: true
  },
  {
    prop: "LimiteDate",
    label: "Fecha Compromiso",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "ClosedDate",
    label: "Fecha Cierre",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  }
];

// export default [
//   {
//     prop: "DisplayObjet",
//     label: "# Obj.",
//     width: 100,
//     sortable: true
//   },
//   {
//     prop: "ObjetiveName",
//     label: "Objetivo",
//     minWidth: 180,
//     sortable: true
//   },
//   {
//     prop: "ObjectiveOwnerName",
//     label: "Responsable Objetivo",
//     sortable: true,
//     formatter: ImagePerson,
//     minWidth: 200,
//     attrs: {
//       imgKey: "ObjectiveOwnerImage"
//     }
//   },
//   {
//     prop: "Id",
//     label: "# Tr.",
//     width: 80,
//     sortable: true
//   },
//   {
//     prop: "Name",
//     label: "Tarea",
//     minWidth: 180,
//     sortable: true
//   },
//   {
//     prop: "Responsable",
//     label: "Responsable Tarea",
//     sortable: true,
//     formatter: ImagePerson,
//     minWidth: 200,
//     attrs: {
//       imgKey: "ImageResponsable"
//     }
//   },
//   {
//     prop: "InitialDate",
//     label: "Fecha Inicio",
//     width: 200,
//     sortable: true,
//     formatter: CellDateTime
//   },
//   {
//     prop: "LimiteDate",
//     label: "Fecha Compromiso",
//     width: 200,
//     sortable: true,
//     formatter: CellDateTime
//   },
//   {
//     prop: "ClosedDate",
//     label: "Fecha Cierre",
//     width: 200,
//     sortable: true,
//     formatter: CellDateTime
//   },
//   {
//     prop: "TotalDueDays",
//     label: "Días de atraso",
//     width: 150,
//     sortable: true
//   },
//   // {
//   //   prop: "Status",
//   //   label: "Estatus",
//   //   width: 130,
//   //   sortable: true,
//   //   attrs: {
//   //     tagType: "success",
//   //     tagValue: "palomo"
//   //   },
//   //   formatter: SuperTagHelper
//   // },
//   {
//     prop: "PercentageProsposal",
//     label: "%",
//     width: 80,
//     sortable: true
//   }
// ];
